//TODO: IMPORTS
import "./address-selector";
import "./../country-selector/country-selector";
import "./../country-selector/country-state-selector";

import { html, PropertyValueMap, TemplateResult} from "lit";
import { connect } from "pwa-helpers";
import { nothing } from "lit-html";
import { map } from 'lit/directives/map.js';
import "../popover/popover";
import { Popover } from "../popover/popover";
import { ifDefined } from 'lit-html/directives/if-defined.js';
import { customElement, property, state, query } from "lit/decorators.js";
import { FormBaseComponent } from "../base-component/forms/form-base-component";
import store, { waitForCountry } from "../../store/store";
import { booleanConverter } from "../../common/converters";
import { RmsBookstoreAddress } from "../checkout/shop-checkout.interface";
import { Modal } from "../modal/modal";
import { calculateFreight, getBillingAddress, getFreightCalculationError, getFreightCalculationStatus, getShippingAddress, isShippingAddressFromAddressbook, updateBillingAddress, updateIsShippingAddressFromAddressbook, updateShippingAddress, updateSkipFreightCalculation } from "../checkout/shop-checkout";
import { StoreState } from "../../store/store.interface";
import emit from "../../common/events";
import { fetchUserProfile } from "../user-profile/user-profile.thunks";
import { isTunnelPurchaseFlow, wait } from "../../common/utils/util";
import { fetchAddressBook } from "./store/address-book.thunks";
import { getCart, getProductCountryCode, isK12CustomStoreAdmin } from "../cart/shop-cart/store/shop-cart.selectors";
import { getAddressBookResponse, getLastAddressResponse, isLoadingAddressBook, isSuccessAddressBook } from "./store/address-book.selectors";
import { getCountryStatus } from "../country-selector/country";
import { ActionStatus } from "../../common/constants/action-status";
import { countryHasStates, getCountryStateStatus } from "../country-selector/country-state";
import { getAddressValidationError, getAddressValidationStatus, validateAddress } from "./store/address-validation";
import { handleApiError } from "../../common/utils/api-utils";
import { selectUser } from "../user-profile/user-profile.selectors";
import { StreetValidationRequest } from "./interfaces/address-validation.interface";
import { defaultApiState, loading } from "../../common/constants/api-constants";
import { Select } from "../selector/selector";
import { AddressSelector } from "./address-selector";
import { addAnalyticsCheckoutFlowMetadata } from "../../common/utils/cart-util";
import { isGuestCheckoutPage } from "../../common/environment";
import { waitForElementAndFocus } from "../../common/utils/a11y-util";
import {
  getDoubleQuoteErrorMessage,
  getDoubleQuoteValidationPattern,
  getEmptyErrorMessage,
  isAddressValid
} from "../../common/utils/address-util";

export declare interface AddressFormData {
  firstName?: string;
  lastName?: string;
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zipCode: string;
  country?: string;
  phoneNumber?: string;
}

/**
 * Address Form Component. Capture address information from user.
 * Loads users existing addresses
 * Validates address
 * Prepopulates address fields
 */
@customElement('mhecomm-address-form')
export class AddressForm extends connect(store)(FormBaseComponent) {
  
  /**
   * Flag to toggle whether to filter Po Box addresses for address-selector component
   */
  @property({ converter: booleanConverter })
  shouldFilterPoBoxAddress = false;
  
  /**
   * Address type - billing or shipping
   */
  @property()
  type = "";

  /**
   * Flag to toggle whether address is international
   */
  @state()
  private isInternational = false;

  /**
   * Flag to toggle whether to show country-state-selector component 
   */
  @state()
  private showStateAsSelectInput = true;

  @property({reflect: true})
  firstName = "";

  @property({reflect: true})
  lastName = "";

  @property({reflect: true})
  streetAddress = "";

  @property({reflect: true})
  unit = "";

  @property({reflect: true})
  city = "";

  /**
   * Default country selected for address form is US
   */
  @property({reflect: true})
  countryCode = '';

  @property({reflect: true})
  countryState = "";

  @property({reflect: true})
  zipCode = "";

  @property({reflect: true})
  phoneNum = "";

  @property({type: Number})
  partySiteId?: number = undefined;
  
  @state()
  private isLoading = true;

  @state()
  private loadFailed = false;

  @state()
  private addressBook: RmsBookstoreAddress[] = [];

  @state()
  private hasExistingAddresses = false;

  private onClickEditAddress = () => {
    this.modal?.close();
    if(this.onClickEditAddressEnhancer){
      this.onClickEditAddressEnhancer();
    }

    // when edit address is clicked in modal then put focus on address input and scroll it into view
    wait(300).then(() => {
      this.getStreetAddressSelector()?.focus();
      this.getStreetAddressSelector().scrollIntoView({ block: "center" })
    });
  };
  private onClickEditAddressEnhancer?: () => void;
  private modal?: Modal;
  private firstNameId = `firstName`;
  private lastNameId = `lastName`;
  private countryId = `country`;
  private streetAddressId = `street1`;
  private unitId = `street2`;
  private cityId = `city`;
  private stateId = `state`;
  private zipCodeId = `zipCode`;
  private phoneNumId = `phoneNumber`;

  private selectedAddress = 0;
  
  private collapse: any;

  @query('#what-is-this-for')
  private whatIsThisForPopover?: Popover;
  
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('input', this.onAddressInput);
    this.addEventListener('mhecomm-country-selected', this.onSelectCountry);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('input', this.onAddressInput);
    this.removeEventListener('mhecomm-country-selected', this.onSelectCountry);
  }

  onAddressInput(event: Event){
    const e = event as InputEvent;
    const targetId = (e.composedPath()[0] as Element).id;
    if ( targetId != this.firstNameId && targetId != this.lastNameId && targetId != this.phoneNumId){
      this.partySiteId = undefined;
      if(isShippingAddressFromAddressbook(store.getState() as StoreState)){
        store.dispatch(updateIsShippingAddressFromAddressbook(false));
      }
    }
  }

  onSelectCountry(e: Event){
    this.countrySelected((e as CustomEvent).detail.selectedCountry, true);
    this.bindListnersForInputChangeEvent();
  }

  _onClickInfoPopover() {
    emit({
      element: this,
      name: 'click-what-is-this-for-popover',
      dataLayer: true
    });
  }

  protected async firstUpdated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.firstUpdated(_changedProperties);
    store.dispatch(fetchUserProfile());
    if(!isTunnelPurchaseFlow() && !isGuestCheckoutPage()) {
      await store.dispatch(fetchAddressBook());
    }
    const state = store.getState() as StoreState;
    const userBusinessUnit = getCart(state)?.userBusinessUnit;
    const previouslyEnteredAddress = this.type === "shipping"?  getShippingAddress(state) : getBillingAddress(state);
    let lastAddress = previouslyEnteredAddress;
    if (userBusinessUnit === 'HE') {
      lastAddress = previouslyEnteredAddress || getLastAddressResponse(state,this.type);
    }
    if(lastAddress){
      if(!previouslyEnteredAddress && this.type === 'shipping'){
        store.dispatch(calculateFreight());
      }
      this.type === 'shipping' ? store.dispatch(updateShippingAddress(lastAddress)) : store.dispatch(updateBillingAddress(lastAddress));
      waitForCountry();
      this.prepopulate(lastAddress);
    }

    if(!this.countryCode){
      let countryCode = "US";
      if(isTunnelPurchaseFlow()){
        countryCode = getProductCountryCode(store.getState() as StoreState);
      }
      this.countrySelected(countryCode)
    }
    if (!this.loadFailed)
      this.componentLoaded();
  }

  protected updated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.updated(_changedProperties);
    this.collapse = this.bsInit('#addUnitOption', window.bootstrap?.Collapse, { toggle: false })?.instance;

    if(_changedProperties.has("focusOnFirstField") && this.focusOnFirstField === true) {
      waitForElementAndFocus(this.shadowRoot!, `#${this.firstNameId}`);
    }
  }

  stateChanged(state: StoreState) {
    if(getCountryStatus(state) === ActionStatus.failed || getCountryStateStatus(state) === ActionStatus.failed){
      this.loadFailed = true;
      return;
    }
    if (getAddressValidationStatus(state) === ActionStatus.failed) {
      handleApiError(getAddressValidationError(state));
      return;
    }
    if (getFreightCalculationStatus(state) === ActionStatus.failed) {
      handleApiError(getFreightCalculationError(state));
      return;
    }

    const addressBookResponse = getAddressBookResponse(state, this.type);
    if (isSuccessAddressBook(state)) {
      this.hasExistingAddresses = addressBookResponse.length > 0;
      this.addressBook = addressBookResponse;
    }
    
    this.isLoading = getCountryStatus(state) === ActionStatus.loading || isLoadingAddressBook(state);
    const givenName = selectUser(state)?.givenName || '';
    const familyName = selectUser(state)?.familyName || '';
    
    if (!this.firstName && !this.lastName) {
      this.firstName = givenName;
      this.lastName = familyName;
    }

    const phone = selectUser(state)?.phone;
    if (!this.phoneNum && phone) {
      this.phoneNum = phone;
    }
  }

  protected validationMessage(){
    return {
      [this.firstNameId]: {
        required: getEmptyErrorMessage('first name'),
        pattern: getDoubleQuoteErrorMessage('First name'),
      },
      [this.lastNameId]: {
        required: getEmptyErrorMessage('last name'),
        pattern: getDoubleQuoteErrorMessage('Last name'),
      },
      [this.cityId]: {
        required: getEmptyErrorMessage('city'),
        pattern: getDoubleQuoteErrorMessage('City'),
      },
      [this.streetAddressId]: {
        required: getEmptyErrorMessage('address'),
        pattern: getDoubleQuoteErrorMessage('Address'),
      },
      [this.stateId]: {
        required: getEmptyErrorMessage('state'),
        pattern: getDoubleQuoteErrorMessage('State'),
      },
      [this.unitId]: {
        pattern: getDoubleQuoteErrorMessage('Unit'),
      },
      [this.zipCodeId]: {
        required: "Please enter a valid zipcode",
        pattern: () => {
          if(this.countryCode === "US") {
            return "Zip code format invalid (US zip code must be either 5 or 10 digits only).";
          } else {
            return "Zip code cannot contain special characters or be more than 10 digits";
          }
        }
      },
      [this.phoneNumId]: {
        required: "Please enter a valid phone number",
        pattern: () => {
          if(this.phoneNum.length < 4 || this.phoneNum.length > 20) {
            return "Please enter a valid phone number between 4-20 digits long.";
          } else {
            return "Special characters other than ( ), - and prefix + are not allowed.";
          }
        }
      },
    };
  }

  /**
   * Prepopulate city, state and zipcode with selected address suggestion data
   * @param e 
   */
  async onStreetAddressSuggestionSelect(e: Event){
    const event = e as CustomEvent;
    const newAddress: StreetValidationRequest = event.detail.addressInfo;
    this.streetAddress = `${newAddress.street1}${newAddress.street2 ? ' '+newAddress.street2 : ''}`;
    this.city = newAddress.city;
    this.countryState = newAddress.state;
    this.zipCode = newAddress.zipCode;
    newAddress.country = this.countryCode;
    try{
      const addressValidationResponse = await this.validateInputAddress(newAddress,true);
      this.type === "shipping" ?  store.dispatch(updateShippingAddress(addressValidationResponse)) : store.dispatch(updateBillingAddress(addressValidationResponse));
      if(addressValidationResponse && isAddressValid(addressValidationResponse)){
        store.dispatch(updateSkipFreightCalculation(false));
        if(this.type === "shipping"){
          store.dispatch(calculateFreight());
        }
      }
      this.validateFields();
    }
    catch(error){
      console.error(`failed to validate ${this.type} address`,error);
    }
  }

  /**
   * On select country update flags isInternational and showStateAsSelectInput 
   * which will update the address form accordingly.
   * Reset the address fields when country changes.
   */
  countrySelected(country: string, resetAddressFields = false){
    if(resetAddressFields){
      this.resetAddressFields();
    }
    this.countryCode = country;
    this.isInternational = this.countryCode != 'US';
    this.showStateAsSelectInput = countryHasStates(country);
  }

  resetAddressFields(announceClearAddress = false) {
    emit({
      element: this,
      name: 'click-clear-address-btn-link',
      dataLayer: true
    });
    this.streetAddress = '';
    this.unit = '';
    this.city = '';
    this.countryState = '';
    this.zipCode = '';
    this.selectedAddress = 0;
    this.countrySelected('');

    this.getCountrySelector().validateFields();
    this.validateFields();

    // Reset the alert message after 3 seconds to ensure it can be read again
    if (announceClearAddress) {
      const alertDiv = this.shadowRoot?.getElementById('clear-address-alert');
      if (alertDiv) {
        alertDiv.textContent = "Address has been cleared";
        setTimeout(() => {
          alertDiv.textContent = "";
        }, 3000);
      }
    }

    // close "What is this  for" popover if open
    if (this.whatIsThisForPopover) {
      this.whatIsThisForPopover.closePopover();
    }
  }

  renderComp() {
    return this.loadFailed ? nothing : 
      html`${this.isLoading ? html`
        <span class="visually-hidden">Loading address form</span>
        ${loading({ columns: 2 })}
        ${loading({ columns: 1, m: 'mt-4', width: '25%' })}
        ${loading({ columns: 1, m: 'mt-3' })}
        ${loading({ columns: 1, m: 'mt-4', width: '25%' })}
        ${loading({ columns: 1, m: 'mt-3' })}
        ${loading({ columns: 1, m: 'mt-4', width: '25%' })}
        ${loading({ columns: 1, m: 'mt-3' })}
      ` : html`
        ${(this.hasExistingAddresses && this.addressBook) ? html`
          <button id="address-book" @click=${() => this.openmodal()} class="btn btn-outline-primary w-100 mb-3">Address Book</button>
        ` : nothing}
        ${!isTunnelPurchaseFlow() ? html`<p><small>All fields are required unless otherwise noted.</small></p>` : nothing}
        <form id="${this.id}" class="row g-3" novalidate @submit=${this.submit}>
          <div class="col-sm-6 col-md-6">
            <label for="${this.firstNameId}" class="form-label">First Name</label>
            <input type="text" class="form-control" id="${this.firstNameId}" .value="${this.firstName}" 
              @input=${(_e: InputEvent) => this.firstName = (_e.target as HTMLInputElement).value} required
              pattern="${getDoubleQuoteValidationPattern()}"
              aria-describedby="${this.firstNameId}-field-error" autocomplete="given-name">
          </div>
          <div class="col-sm-6 col-md-6">
            <label for="${this.lastNameId}" class="form-label">Last Name</label>
            <input type="text" class="form-control" id="${this.lastNameId}" .value="${this.lastName}"
              @input=${(_e: InputEvent) => this.lastName = (_e.target as HTMLInputElement).value} required
              pattern="${getDoubleQuoteValidationPattern()}"     
              aria-describedby="${this.lastNameId}-field-error" autocomplete="family-name">
          </div>
          <div class="col-12">
            <mhecomm-country-selector 
              id="${this.countryId}" 
              type="${this.type}" 
              label="Country"
              selectedOption="${this.countryCode}"
              errorMessage="Please enter a valid country"
              ?isdirty=${this.isDirty}
              required>
            </mhecomm-country-selector>
          </div>
          <div class="col-12">
            ${this.streetAddressInput()}
            ${this.shouldFilterPoBoxAddress ? 
              html`<span>At this time we cannot ship to P.O. Box addresses.</span>`
              : nothing
            }
          </div>

          <div class="col-12">
            <button
              type="button"
              class="text-decoration-none btn btn-link p-0"
              data-bs-target="#addUnitOption"
              data-bs-toggle="collapse"
              aria-controls="addUnitOption"
              aria-expanded="false"
              id="addUnitOptionLink"
              aria-label="Unit optional"
              @click=${this._handleCollapseToggle}
              @keydown=${(e: KeyboardEvent) => e.key === 'Enter' && this._handleCollapseToggle(e)}>
              Unit (optional)
              ${this.uxtIconReady ? html`
                <uxt-icon id="enterDropDownIcon" icon="chevron-down" aria-hidden="true"></uxt-icon>
              `: ''}
            </button>
            <div class="collapse" id="addUnitOption">    
              <label for="${this.unitId}" class="form-label mt-2">Unit (optional)</label>
              <input 
                type="text" 
                class="form-control" 
                id="${this.unitId}" 
                .value="${this.unit ? this.unit: ''}"
                @input=${(_e: InputEvent) => this.unit = (_e.target as HTMLInputElement).value} 
                placeholder="Apt, Suite, Building, Floor, etc."
                pattern="${getDoubleQuoteValidationPattern()}"
                autocomplete="address-line2"
                aria-describedby="${this.unitId}-field-error">
            </div>
          </div>

          <div class="col-12">
            <label for="${this.cityId}" class="form-label">City</label>
            <input type="text" class="form-control" id="${this.cityId}" .value="${this.city}"
              @input=${(_e: InputEvent) => this.city = (_e.target as HTMLInputElement).value} required
              pattern="${getDoubleQuoteValidationPattern()}"     
              aria-describedby="${this.cityId}-field-error" autocomplete="address-level2">
          </div>
          <div class="col-sm-6 col-md-6">
            ${this.stateInput()}
          </div>
          <div class="col-sm-6 col-md-6">
            <label for="${this.zipCodeId}" class="form-label">Zip Code</label>
            <input type="text" class="form-control" id="${this.zipCodeId}" .value="${this.zipCode}"
              @input=${(_e: InputEvent) => this.zipCode = (_e.target as HTMLInputElement).value} pattern="${ifDefined(this.countryCode === 'US' ? "(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)" : "(^[a-zA-Z0-9][a-zA-Z0-9\\- ]{0,10}[a-zA-Z0-9]$)")}" required
              aria-describedby="${this.zipCodeId}-field-error" autocomplete="postal-code">
          </div>
          <div class="col-md-6">
            <label for="${this.phoneNumId}" class="form-label">Phone Number</label>
            <span class="float-end">
              <mhecomm-popover 
                @click=${this._onClickInfoPopover} 
                id="what-is-this-for" 
                label="What is this for?" 
                text="In case we need to contact you about your order."
                ariaLabel="What is this for?"
                disableLinkUnderline=true
              >
              </mhecomm-popover>
            </span>
            <input type="text" class="form-control" id="${this.phoneNumId}" .value="${this.phoneNum}" 
              @input=${(_e: InputEvent) => this.phoneNum = (_e.target as HTMLInputElement).value} pattern="^\\+?([0-9\\-\\(\\)\\s]{4,20})$" required
              aria-describedby="${this.phoneNumId}-field-error" autocomplete="tel">
          </div>
          <div id="clear-address-alert" class="visually-hidden" role="alert"></div>
          <div class="col-md-6 d-flex align-items-center">
            <button
              id="clear-address"
              type="button"
              class="btn btn-link p-0 mt-2"
              aria-label="Clear Address"
              @click=${() => this.resetAddressFields(true)}
              part="button">
              Clear Address
            </button>
          </div>
        </form>`
      }`;
  }

  /**
   * 
   * @returns text input for street address if address form is for non-US country else returns address-selector
   */
  streetAddressInput(): TemplateResult {
    return  html` ${this.isInternational? html`
      <label for="${this.streetAddressId}" class="form-label">Street Address</label>
      <input type="text" class="form-control" id="${this.streetAddressId}" @input=${(_e: InputEvent) => this.streetAddress = (_e.target as HTMLInputElement).value} .value="${this.streetAddress}"
      required aria-describedby="${this.streetAddressId}-field-error" pattern="${getDoubleQuoteValidationPattern()}" autocomplete="address-line1"/>
    ` : html `
      <mhecomm-address-selector 
        id="${this.streetAddressId}" type="${this.type}" country="US" 
        ?shouldfilterpoboxaddress=${this.shouldFilterPoBoxAddress} 
        placeholder="" .required=${true}
        .addressInput=${this.streetAddress}
        errorMessage="Please enter a valid street address"
        @mhecomm-address-info="${this.onStreetAddressSuggestionSelect}"
        ?isdirty=${this.isDirty}
        label="Street Address">
      </mhecomm-address-selector>
    `}`;
  }
  /**
   * 
   * @returns state selector component if showStateAsSelectInput is true else returns text input field
   */
  stateInput(): TemplateResult {
    return html`${this.showStateAsSelectInput ? html`
    <mhecomm-country-state-selector 
      id="${this.stateId}" 
      type="${this.type}" 
      label="State"
      countryCode="${this.countryCode}"
      selectedOption="${this.countryState}"
      errorMessage="Please enter a valid state"
      ?capitalize=${true}
      ?isdirty=${this.isDirty}
      required>
    </mhecomm-country-state-selector>` : html `
      <label for="${this.stateId}" class="form-label">State</label>
      <input
        type="text" 
        class="form-control"
        id="${this.stateId}"
        @input=${(_e: InputEvent) => this.countryState = (_e.target as HTMLInputElement).value}
        pattern="${getDoubleQuoteValidationPattern()}"
        .value="${this.countryState}" required aria-describedby="${this.stateId}-field-error"
        autocomplete="address-level1"
      />
    `}`;
  }

  private componentLoaded() {
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('address-form-loaded'));
    }, 0);
    this.isLoading = false;
  }

  private handleSelectAddress() {
    const address: RmsBookstoreAddress = {...this.addressBook[this.selectedAddress]}
    this.partySiteId = address.partySiteId;
    this.countryCode = address.country ? address.country : '';
    this.streetAddress = address.address1 ? address.address1 : '';
    this.unit = address.address2 ? address.address2 : '';
    this.city = address.city ? address.city : '';
    this.countryState = address.state ? address.state : '';
    this.zipCode = address.zipCode ? address.zipCode : '';
    address.firstName = this.firstName;
    address.lastName = this.lastName;
    address.phoneNumber = this.phoneNum;
    if(this.type === "shipping") {
      store.dispatch(updateShippingAddress(address));
      store.dispatch(updateIsShippingAddressFromAddressbook(true));
    } else {
      store.dispatch(updateBillingAddress(address));
    }
    if (this.type === "shipping" && !isK12CustomStoreAdmin(store.getState() as StoreState)) {
      store.dispatch(calculateFreight());
    }
  }

  private getAddresBookTemplate(){
    return html `
      <style>#addressBook { max-height : 60vh;}</style>
      <h5 class="mb-4"> Choose a shipping address </h5>
      <div id="addressBook" class="overflow-auto ps-1">
        ${this.addressBook.map((address: RmsBookstoreAddress, index: number) => html `
          <div class="form-check" @click="${ () => {this.selectAddress(index)}}">
            <input class="form-check-input" type="radio" id="address-${index}" name="address" value="${index}" ?checked=${index === this.selectedAddress}>
            <label class="form-check-label" for="address-${index}">${address.address1},${address.city},${address.state} ${address.zipCode}</label>
          </div> 
        `)}
      </div>
    `
  }

  private newAddress(){
    this.resetAddressFields();
    this.selectedAddress = 0;
    emit({
      element: this,
      name: 'address-form-closeModal',
      detail: {id: this.id},
    });
  }

  private selectAddress(index: number) {
    this.selectedAddress = index;
  }

  private async openVerifyAddressModal(addressData: any) {
    return new Promise<void>((resolve, reject) => {
      const address = html`
      <div class="alert alert-primary" role="alert">
        <p class="m-0"><span class="fw-bold">There was no match found for your ${this.type} address</span> ${this.type === 'shipping' ? '- Please enter a valid shipping address' : ''}</p>
      </div>
      <p class="ps-3 fw-bold">
          ${addressData.street1} ${addressData.street2}<br/>
          ${addressData.city}, ${addressData.state}, ${addressData.country}, ${addressData.zipCode}
      </p>
      `;
      if(this.type === 'shipping'){
        const buttonLabel = "Edit Address";
        this.modal = new Modal({
          modalContext: {componentRef: 'verifyAddressModal'},
          header: 'Verify your shipping address', 
          body: {template: address},
          primaryButton: {label: buttonLabel, ariaLabel: buttonLabel}
        });
        this.modal.addEventListener('mhecomm-modal-confirmed', this.onClickEditAddress);
        this.modal.addEventListener('verifyAddressModal-modal-close', () => resolve());
        this.modal.open();
      } else {
        const primaryButtonLabel = "Edit Address";
        const secondaryButtonLabel = "Continue";
        this.modal = new Modal({
          modalContext: { componentRef: 'verifyAddressModal' },
          header: 'Verify your billing address',
          body: {template: address},
          a11y: {
            announceBody: true
          },
          primaryButton: {label: primaryButtonLabel, ariaLabel: primaryButtonLabel},
          secondaryButton: {label: secondaryButtonLabel, ariaLabel: secondaryButtonLabel},
        });
        this.modal.addEventListener('mhecomm-modal-confirmed', () => {
          reject(defaultApiState);
          this.onClickEditAddress();
        });
        this.modal.addEventListener('verifyAddressModal-modal-close', () => {
          resolve();
          this.dispatchEvent(new CustomEvent('focus-next-step-button', {
            bubbles: true,
            composed: true
          }));  
        });
        this.modal.open();
      }
    });
  }

  private openmodal() {
    const modal: Modal = new Modal({
      header: 'Address Book',
      reversedFooter: true, 
      body: {template: this.getAddresBookTemplate()},
      primaryButton: {label: 'Use this address'},
      customButton: html`<a id="add-new-address" class="link-secondary" role="button" @click="${ () => {this.newAddress()}}">+ add new address</a>`, 
      modalContext: {componentRef: `${this.id}`}
    });
    this.addEventListener('address-form-closeModal', () => {modal.close()});
    modal.addEventListener('mhecomm-modal-confirmed', () => {this.handleSelectAddress(); modal.close()});
    modal.open();
  }

  /**
   * Skip address validation if address has not changed.
   * If form passes basic validation, @returns international street address validation response or US street address validation response.
   */
  public async validate(): Promise<RmsBookstoreAddress | void> {
    if(await this.isAddressFormValid()){
      const newAddress: StreetValidationRequest = {
        country: this.countryCode,
        street1: this.getStreetAddress(),
        street2: this.unit,
        city: this.city,
        state: this.getState(),
        zipCode: this.zipCode
      }
      let currentAddress = this.type === 'shipping' ? getShippingAddress(store.getState() as StoreState) : getBillingAddress(store.getState() as StoreState);
      
      if (currentAddress) {
        currentAddress = {...currentAddress, unit: this.unit, address2: this.unit}
        if (this.type === 'shipping') {
          store.dispatch(updateShippingAddress(currentAddress));
        } else {
          store.dispatch(updateBillingAddress(currentAddress));
        }
      }

      if(currentAddress && this.addressIsSame(currentAddress, newAddress)){
          const address: RmsBookstoreAddress = {...currentAddress};
          address.firstName = this.firstName;
          address.lastName = this.lastName;
          address.phoneNumber = this.phoneNum;
          if(!isAddressValid(address)) {
            await this.openVerifyAddressModal(newAddress);
            return address;
          }
          else{
            return address;
          }
      } else {
        return await this.validateInputAddress(newAddress);
      }
    }
    return;
  }

  async validateInputAddress(newAddress: StreetValidationRequest, skipErrorModalDisplay = false){
    const addressValidationResponse = await store.dispatch(validateAddress(newAddress)).unwrap();
    if(!skipErrorModalDisplay && !isAddressValid(addressValidationResponse)) {
      await this.openVerifyAddressModal(newAddress);
      const address: RmsBookstoreAddress = {
        firstName: this.firstName,
        lastName: this.lastName,
        ...addressValidationResponse,
        phoneNumber: this.phoneNum
      }
      return address;
    } else {
      const address: RmsBookstoreAddress = {
        firstName: this.firstName,
        lastName: this.lastName,
        ...addressValidationResponse,
        phoneNumber: this.phoneNum
      }
      return address;
    }
  }

  addressIsSame(currentAddress: RmsBookstoreAddress, newAddress: StreetValidationRequest){
    return currentAddress.address1 === newAddress.street1 &&
       currentAddress.zipCode === newAddress.zipCode &&
       currentAddress.city === newAddress.city &&
       currentAddress.state === newAddress.state &&
       currentAddress.country === newAddress.country &&
       (!currentAddress.address2 || currentAddress.address2 === newAddress.street2);
  }
  /**
   * 
   * @returns validates if the required fields are not empty
   */
  private async isAddressFormValid() {
    return await this.isFormValid() && // check address form is valid or not
      (!this.isInternational ? await this.getStreetAddressSelector().isFormValid() : true) && // check Street Selector form is valid or not
      (this.showStateAsSelectInput ? await this.getStateSelector().isFormValid() : true) && // check State form is valid or not
      await this.getCountrySelector().isFormValid(); // check Country Selector is valid or not
  }

  /**
   * Prepopulate address form given AddressFormData
   * @param addressFormData 
   */
  public prepopulate(addressFormData: RmsBookstoreAddress){
    this.firstName = addressFormData.firstName;
    this.lastName = addressFormData.lastName;
    this.countrySelected(addressFormData.country);
    this.streetAddress = addressFormData.address1;
    this.unit = addressFormData.address2!;
    this.countryState = addressFormData.state;
    this.city = addressFormData.city;
    this.zipCode = addressFormData.zipCode;
    this.phoneNum = addressFormData.phoneNumber;
  }

  private getStreetAddressSelector(){
    return (this.shadowRoot?.querySelector(`#${this.streetAddressId}`)  as AddressSelector);
  }

  private getStateSelector(){
    return (this.shadowRoot?.querySelector(`#${this.stateId}`) as Select);
  }

  private getCountrySelector(){
    return (this.shadowRoot?.querySelector(`#${this.countryId}`) as Select);
  }

  private getStreetAddress(){
    return this.isInternational ? this.streetAddress
      : this.getStreetAddressSelector().addressInput;
  }

  private getState(){
    return this.showStateAsSelectInput? this.getStateSelector().getSelectedOption():
      this.countryState;
  }

  public isAddressInternational(): boolean{
    return this.isInternational;
  }

  public setOnClickEditAddress(onClickEditAddressEnhancer: () => void){
    this.onClickEditAddressEnhancer = onClickEditAddressEnhancer;
  }

  _handleCollapseToggle(event: Event) {
    if (event) {
      const button = this.shadowRoot!.querySelector('#addUnitOptionLink') as HTMLButtonElement;
      const dropDownIcon = this.shadowRoot!.querySelector('#enterDropDownIcon');
      const currentlyExpanded = button.getAttribute('aria-expanded') === 'true';
      this.collapse.toggle();
      setTimeout(() => {
        const isExpanded = !currentlyExpanded;
        button.setAttribute('aria-expanded', isExpanded.toString());
        if (!isExpanded) {
          dropDownIcon?.setAttribute('icon', 'chevron-down');
          this.analyticsUnitUnexpanded();
        } else {
          dropDownIcon?.setAttribute('icon', 'chevron-up');
          this.analyticsUnitExpanded();
        }
      }, 0);
    }
  }
  
  analyticsUnitExpanded() {
    emit({
      name: 'click',
      element: this,
      detail: addAnalyticsCheckoutFlowMetadata({
        eventName: 'unit-field-expanded',
        label: "Unit (Optional)",
        value: this.unit
      })
    })  
  }

  analyticsUnitUnexpanded() {
    emit({
      name: 'click',
      element: this,
      detail: addAnalyticsCheckoutFlowMetadata({
        eventName: 'unit-field-unexpanded',
        label: "Unit (Optional)",
        value: this.unit
      })
    })
  }

  protected createErrorElement(element: HTMLInputElement): string {
    const fieldLabel = element?.labels?.[0]?.textContent?.trim() ?? '';
    return `
      <p
        class="invalid-feedback mb-1 d-block"
        role="alert"
        aria-atomic="true"
      >
        <span class="visually-hidden">${fieldLabel} field has an error.&nbsp;</span>
        <span id="${element.id}-field-error">
          <uxt-icon icon="exclamation-triangle"></uxt-icon>
          <span class="visually-hidden">Error&nbsp;</span>${element.validationMessage}
        </span>
      </p>
    `;
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-address-form': AddressForm;
  }
}
